import { render } from "./approval.vue?vue&type=template&id=6239df54&scoped=true"
import script from "./approval.vue?vue&type=script&lang=js"
export * from "./approval.vue?vue&type=script&lang=js"

import "./approval.vue?vue&type=style&index=0&id=6239df54&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6239df54"

export default script